const DEFAULT_CDN = "https://driqq8crwypb5.cloudfront.net";

export const getPublicCdnBase = () => {
  const base = process.env.VUE_APP_PUBLIC_CDN_URL || DEFAULT_CDN;
  return base.replace(/\/$/, "");
};

export const isAbsoluteUrl = (value) =>
  typeof value === "string" &&
  (value.startsWith("http://") || value.startsWith("https://"));

export const resolvePublicUrl = (keyOrUrl) => {
  if (!keyOrUrl) return "";
  const value = String(keyOrUrl).trim();
  if (!value) return "";
  if (isAbsoluteUrl(value)) return value;
  return `${getPublicCdnBase()}/${value.replace(/^\//, "")}`;
};

export const resolvePrivateFileUrl = async (keyOrUrl) => {
  if (!keyOrUrl) return "";
  const value = String(keyOrUrl).trim();
  if (!value) return "";
  if (isAbsoluteUrl(value) && value.includes("?")) return value;

  const filesApi = process.env.VUE_APP_FILES;
  const token = localStorage.getItem(process.env.VUE_APP_AUTH_TOKEN);
  const response = await fetch(`${filesApi}getFileFromUrl`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ fileUrl: value }),
  });

  if (!response.ok) {
    throw new Error("Failed to resolve private file URL");
  }

  return response.text();
};
